//src/components/common/sidebar/SidebarMenu.tsx
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { SidebarMenuItem } from "@/components/common";
import { ScrollArea } from "@/components/ui";
import { fetchMenuItems } from "@/data/menu";
import type { MenuItem } from "@/types";

type SidebarMenuProps = {
    isCollapsed: boolean;
};

export function SidebarMenu({ isCollapsed }: SidebarMenuProps) {
    const location = useLocation();
    const [expandedItemId, setExpandedItemId] = useState<string | null>(null);
    const [menuItems, setMenuItems] = useState<MenuItem[]>([]);

    // TODO: Replace with actual auth implementation
    const userRole = 'admin'; // This should come from your auth system

    useEffect(() => {
        const loadMenuItems = async () => {
            const items = await fetchMenuItems(userRole);
            setMenuItems(items);
        };

        loadMenuItems();
    }, [userRole]);

    return (
        <ScrollArea className="flex-1 px-1 py-4">
            <div className="space-y-2">
                {menuItems.map((item) => (
                    <SidebarMenuItem
                        key={item.id}
                        item={item}
                        isCollapsed={isCollapsed}
                        currentPath={location.pathname}
                        isExpanded={expandedItemId === item.id}
                        onExpand={(itemId) => setExpandedItemId(itemId === expandedItemId ? null : itemId)}
                    />
                ))}
            </div>
        </ScrollArea>
    );
} 